import React from 'react';
import { AssessmentTab, JobOpeningTab, UsersTab } from '../Containers';
import type { IAdminPanelTabDef } from '../interfaces';
export type { IAdminPanelTabDef };

export enum ADMIN_PANEL_TAB {
  USER = 'User',
  JOB_OPENING = 'Job Opening',
  ASSESSMENT = 'Assessment',
}

/**
 * URL-safe slugs for each dashboard tab.
 * Slugs (not display labels) drive the route: /home/<slug>.
 * Keeps URLs shareable, deep-linkable and refresh-safe.
 */
export enum ADMIN_PANEL_TAB_SLUG {
  JOB_OPENING = 'job-openings',
  ASSESSMENT = 'assessments',
  USER = 'users',
}

export const ADMIN_PANEL_TABS: IAdminPanelTabDef[] = [
  { label: 'Job Opening', value: ADMIN_PANEL_TAB.JOB_OPENING, slug: ADMIN_PANEL_TAB_SLUG.JOB_OPENING, component: JobOpeningTab },
  { label: 'Assessment', value: ADMIN_PANEL_TAB.ASSESSMENT, slug: ADMIN_PANEL_TAB_SLUG.ASSESSMENT, component: AssessmentTab },
  { label: 'User', value: ADMIN_PANEL_TAB.USER, slug: ADMIN_PANEL_TAB_SLUG.USER, component: UsersTab },
];

export const DEFAULT_ADMIN_PANEL_SLUG = ADMIN_PANEL_TAB_SLUG.JOB_OPENING;

export const adminTabSlugToValue = (slug: string | undefined): ADMIN_PANEL_TAB => {
  const found = ADMIN_PANEL_TABS.find((tab) => tab.slug === slug);
  return found?.value ?? ADMIN_PANEL_TAB.JOB_OPENING;
};

export const adminTabValueToSlug = (value: string): ADMIN_PANEL_TAB_SLUG => {
  const found = ADMIN_PANEL_TABS.find((tab) => tab.value === value);
  return found?.slug ?? DEFAULT_ADMIN_PANEL_SLUG;
};

/** a11y helper: pairs <Tab id> with its panel aria-controls. */
export const getAdminTabA11yProps = (slug: ADMIN_PANEL_TAB_SLUG) => ({
  id: `dashboard-tab-${slug}`,
  'aria-controls': `dashboard-tabpanel-${slug}`,
});
